var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgTradePriceIcon = function SvgTradePriceIcon(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00EA90",
    d: "M19.404-.01c-6.611 0-13.647.003-14.839.003-1.192 0-2.75.422-3.809 1.994C-.27 3.511-.274 5.896.883 7.086c1.157 1.19 14.397 14.7 15.234 15.594.837.895 2.68 1.825 5.054.975 2.373-.85 2.768-2.761 2.81-3.866.042-1.105 0-13.85 0-15.21 0-1.36-.212-2.464-.975-3.272C22.038.282 21.1-.01 19.404-.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.823 14.172c-.238 0-.423-.065-.553-.196-.123-.138-.185-.326-.185-.564v-6.22H12.84c-.2 0-.357-.055-.472-.162a.648.648 0 0 1-.162-.461c0-.2.054-.35.162-.45.115-.107.272-.16.472-.16h5.967c.2 0 .354.053.461.16.115.1.173.25.173.45a.623.623 0 0 1-.173.46c-.107.108-.26.162-.46.162H16.56v6.22c0 .239-.061.427-.184.565-.123.13-.308.196-.553.196Z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTradePriceIcon;